<template>
  <textarea
    class="form-control"
    v-bind="$attrs"
    :value="value"
    @input="event => $emit('update', event.target.value)"
    v-on="$listeners"
  ></textarea>
</template>

<script>
export default {
  name: 'TsTextarea',
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'update'
  },
  props: ['value']
}
</script>
